import React from 'react';

import { appMethod as app } from '@utils/app';
import { transformPx2Rem, convertStyleData } from '@utils/tools';

import './TopicClassifyCustomComponent.less';


/**
 * type: "topic-classify" 
 * 组件：话题分类组件
 */

export default class TopicClassifyCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let {
      customFeature,
    } = pageInstance.data.eles[compindex];
    // 设置param
    let param = customFeature;
    // 感觉后面topic可直接用customFeature
    pageInstance.setData({
      ['eles[' + compindex + '].param']: param
    });
    let newdata = {};
    let topicCompIndex = app.findComponentIndexById(customFeature.topic_refresh_object, pageInstance);
    if (topicCompIndex > -1) {
      let topicList = pageInstance.data.eles[topicCompIndex].customFeature;
      newdata['eles[' + compindex + '.relateTopicCompIndex'] =  topicCompIndex;
      newdata['eles[' + topicCompIndex + '.relateClassifyCompIndex'] =  compindex;
      newdata['eles[' + compindex + '.selectedSectionId'] =  topicList.bindPlate;
      newdata['eles[' + compindex + '.selectedCategoryId'] =  topicList.bindTopic;
      pageInstance.setData(newdata);
    }else {
      app.showModal({content: '话题分类未找到绑定的话题列表'});
    }
  }

  switchTopicCategory = (e) => {
    let currentTarget = e.currentTarget,
      dataset = currentTarget.dataset,
      compindex = dataset.compindex,
      section_id = dataset.sectionid || 0,
      category_id = dataset.categoryid || 0,
      topicCompIndex = dataset.topicCompindex,
      pageInstance = app.getAppCurrentPage(),
      newdata = {};

    if (topicCompIndex) {
      let searchCompIndex = pageInstance.data.eles[topicCompIndex].relateSearchCompIndex;

      newdata['eles[' + compindex + '].selectedSectionId'] = section_id;
      newdata['eles[' + compindex + '].selectedCategoryId'] = category_id;
      newdata['eles[' + topicCompIndex + '].listStatus.loading'] = false;
      newdata['eles[' + topicCompIndex + '].listStatus.isMore'] = true;
      newdata['eles[' + topicCompIndex + '].listParam.search_value'] = '';
      newdata['eles[' + topicCompIndex + '].topicList'] = [];

      if (searchCompIndex && searchCompIndex > -1) {
        newdata['eles[' + searchCompIndex + '].searchValue'] = '';
      }
      newdata['eles[' + topicCompIndex + '].listParam.page'] = 1;
      newdata['eles[' + topicCompIndex + '].listParam.section_id'] = section_id;
      newdata['eles[' + topicCompIndex + '].listParam.category_id'] = category_id;

      pageInstance.setData(newdata);
      pageInstance.callComponentMethod({
        componentIndex: topicCompIndex,
        methodName: 'getTopListData',
        argvs: [topicCompIndex, pageInstance]
      });
    }else {
      app.showModal({content: '话题分类未找到绑定的话题列表'});
    }
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 组件配置对象
    const customFeature = data.customFeature;
    // 商品分类
    const content = data.content;
    // 组件样式
    const styleObj = convertStyleData(data.style);
    // 图片样式
    const imgStyle = {
      width: transformPx2Rem(customFeature.width, 320),
      height: transformPx2Rem(customFeature.height,320),
      marginLeft: transformPx2Rem(customFeature['margin-left']),
      marginTop: transformPx2Rem(customFeature['margin-top']),
      borderRadius: transformPx2Rem(customFeature.picBorderRadius),
    }
    // 被选中样式
    const selectStyle = {
      color: customFeature.selectedColor,
    }

    return (
      <div className="custom-component topic-classify" style={styleObj}>
        {content.map((item,index) => 
          <div className="classify-item"
            key={index}
            style={data.selectedSectionId == item.bindPlate && data.selectedCategoryId == item.classifyId ? selectStyle : {}}
            onClick={this.switchTopicCategory}
            data-compindex={this.props.index}
            data-topic-compindex={data.relateTopicCompIndex}
            data-sectionid={item.bindPlate}
            data-categoryid={item.classifyId}
            >
            <div className="img-wrap">
              <img className="classify-logo" style={imgStyle} src={item.pic} alt=""/>
            </div>
            <div>{item.name}</div>
          </div>
        )}
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/custom-component/topic-classify-custom-component/TopicClassifyCustomComponent.jsx